import React, {Component} from "react";
import withWidth from '@material-ui/core/withWidth';
import {TwitterTweetEmbed} from 'react-twitter-embed';
import Carousel from 'nuka-carousel';

class TwtsCarousel extends Component {

  componentDidMount() {
    // I can probably delete this, still doesnt change height
    // until first time carousel moves bc of the lib
    this.props.checkRefs();
  }

  componentWillUnmount() {
    this.resetALLTimeoutsHack();
  }

  // NOTE nuka-carousel is NOT clearing all their timers on unmount,
  // and its fucking me up with memory errors
  // https://github.com/FormidableLabs/nuka-carousel/issues/100
  // https://github.com/FormidableLabs/nuka-carousel/issues/550
  // NOTE HACK https://stackoverflow.com/a/8860203
  resetALLTimeoutsHack() {
    console.log('resetting all timeouts...')
    let id = window.setTimeout(function() {}, 0);
    while (id--) {
        window.clearTimeout(id); // will do nothing if no timeout with id is present
    }
  }

  render() {
    const {config, width, twts} = this.props;
    // console.log('wide enough?? ', width);
    let visibleTwts;
    let scrollby = 1;
    if (width === 'xs') {
      visibleTwts = 1;
    } else if (width === 'sm') {
      visibleTwts = 2;
    } else {
      visibleTwts = 3;
      scrollby = config.twtsToScrollBy;
    }

      return (
        <Carousel
          slidesToShow={visibleTwts}
          slidesToScroll={scrollby}
          // TODO better fix, check height before everytime carousel moves, twt card height doesn't get set till onFocus...
          beforeSlide={() => this.props.checkRefs()}
          dragging
          autoplay
          pauseOnHover={true}
          autoplayInterval={config.autoInterval}
          speed={config.scrollSpeed}
          withoutControls
          framePadding={config.carouselPadding}
          cellSpacing={config.pxSpaceBetweenTwts}
          wrapAround
          // slideIndex={config.slideIndex}
          transitionMode={config.transitionMode}
          heightMode={config.heightMode}
          cellAlign={config.cellAlign}
        >
          {
            twts.map((twtid) => {
              // if a conversation, do not show the original twt being replied to, takes up too much space
              // can hide pic/video with {cards: 'hidden'}
              // NOTE hiding pic/video due to issues dynamically resizing
              return <TwitterTweetEmbed options={{conversation: 'none', cards: 'hidden'}} key={twtid} tweetId={twtid} />;
            })
          }
        </Carousel>
      );
  }

}

export default withWidth()(TwtsCarousel);



// WEBPACK FOOTER //
// ./src/views/PollTemplate/TwtsCarousel.js